/**
 * Common Scripts used accross all the pages
 */
require('exceptions/sentry-service.js').init();
require('polyfills/samsung-browser-v7.2.js');
require('config/q-library-config.js');
require('components/responsive-nav.js');
require('components/language-switcher-select.js');
require('components/language-switcher-dropdown.js');
require('forms/highlight-labels.js');
require('tracking/tracking-controller.js');
require('tracking/common/tracking-common.js');
require('third-party/intercom-controller.js');
require('third-party/script-inspectlet.js');
